import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})

export class Filter implements PipeTransform {
  transform(items: any[], query: string): any {
    if (!items) return [];
    if (!query) return items;
    query = query.toLowerCase();
    return items.filter(item => item.name.toLowerCase().includes(query) || item.accession_number.toLowerCase().includes(query) || item.ranseps_file.toLowerCase().includes(query));
  }
}
